import { Component } from 'react';
import * as React from 'react';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { LinkPrimaryButton, LinkSecondaryButton, LinkSectionButton } from '../../uiComponents/input/Buttons';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { getSite } from '../../infrastructure/site/SiteProvider';
import { HelpCardSection } from '../../uiComponents/layout/HelpCardSection';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { KonkurrenceTilLaerer } from '../../models/KonkurrenceTilLaerer';
import { EmptyState } from '../../uiComponents/EmptyState';
import KonkurrenceTilInstitutionUdenLaererTable from '../konkurrence/KonkurrenceTilInstitutionUdenLaererTable';
import KonkurrenceTilLaererEksternTable from '../konkurrence/KonkurrenceTilLaererEksternTable';
import { SelectFormControl } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import KonkurrenceOverblikContainer from './konkurrenceOverblik/KonkurrenceOverblikContainer';
import * as moment from 'moment';
import { KonkurrenceOverblik } from '../../models/KonkurrenceOverblik';
import HelperMethods from '../../infrastructure/HelperMethods';
import { Spinner } from '../../uiComponents/Spinner';
import { ValidationResult } from '../../infrastructure/ValidationResult';

export interface SkrivebordLaererProps {
}

export interface SkrivebordLaererState {
    konkurrencer?: KonkurrenceTilLaerer[];
    kommendeKonkurrencer?: KonkurrenceTilLaerer[];
    konkurrencerTilInstitutionerUdenLaerer?: KonkurrenceTilLaerer[];    
    selectedKonkurrenceId?: string;
    konkurrenceOverblik?: KonkurrenceOverblik;
    isLoading: boolean;
    isSubmitting: boolean;
}

class SkrivebordLaerer extends Component<SkrivebordLaererProps, SkrivebordLaererState> {
    constructor(props: SkrivebordLaererProps) {
        super(props);

        this.state = {
            konkurrencer: undefined,
            kommendeKonkurrencer: undefined,
            selectedKonkurrenceId: undefined,
            konkurrenceOverblik: undefined,
            konkurrencerTilInstitutionerUdenLaerer: undefined,
            isLoading: true,
            isSubmitting : false
        };

        this.tilmeldLaererTilKonkurrence = this.tilmeldLaererTilKonkurrence.bind(this);
    }

    componentDidMount() {
        this.getKonkurrencer();        
    }

    getKonkurrencer() {
        let apiCaller = createApiCaller();

        apiCaller.GetAlleKonkurrencerTilLaerer().then((konkurrencer: KonkurrenceTilLaerer[]) => {
            let selectedKonkurrenceId: string | undefined = undefined;
            let konkurrenceOverblik = undefined;            

            if (konkurrencer.length > 0) {
                let snarestKommendeKonkurrence = this.getSnarestkommendeKonkurrence(konkurrencer);
                let senesteKonkurrence = this.getSenesteKonkurrence(konkurrencer);
                
                selectedKonkurrenceId = snarestKommendeKonkurrence !== undefined ? snarestKommendeKonkurrence.id : senesteKonkurrence !== undefined ? senesteKonkurrence.id : undefined;
            }

            if (selectedKonkurrenceId !== undefined && selectedKonkurrenceId.length > 0) {
                apiCaller.getKonkurrenceOverblik(selectedKonkurrenceId).then(response => {
                    konkurrenceOverblik = response;

                    this.setState({
                        konkurrencer: konkurrencer,
                        selectedKonkurrenceId: selectedKonkurrenceId,
                        konkurrenceOverblik: konkurrenceOverblik,
                        isLoading: false
                    });
                });
            } else {
                this.setState({
                    konkurrencer: konkurrencer,
                    selectedKonkurrenceId: selectedKonkurrenceId,
                    konkurrenceOverblik: konkurrenceOverblik,
                    isLoading: false
                });
            }
        });
        
        apiCaller.getKommendeKonkurrencerTilLaerer().then((konkurrencer: KonkurrenceTilLaerer[]) => {
            this.setState({
                kommendeKonkurrencer: konkurrencer
            });
        });

        apiCaller.GetAlleKonkurrencerTilInstitutionUdenLaerer().then((konkurrencer: KonkurrenceTilLaerer[]) => {
            this.setState({
                konkurrencerTilInstitutionerUdenLaerer: konkurrencer
            });
        });
    }

    getSnarestkommendeKonkurrence(konkurrencer: KonkurrenceTilLaerer[]) {
        let konkurrencerSorted = konkurrencer.sort((a: KonkurrenceTilLaerer, b: KonkurrenceTilLaerer) => {
            if (a.dato > b.dato) {
                return 1;
            }
            if (a.dato < b.dato) {
                return -1;
            }
            return 0;
        });

        return konkurrencerSorted.find(konkurrence => new Date(new Date(konkurrence.dato).toDateString()) >= new Date(new Date().toDateString()));
    }

    getSenesteKonkurrence(konkurrencer: KonkurrenceTilLaerer[]) {
        let konkurrencerSorted = konkurrencer.sort((a: KonkurrenceTilLaerer, b: KonkurrenceTilLaerer) => {
            if (a.dato < b.dato) {
                return 1;
            }
            if (a.dato > b.dato) {
                return -1;
            }
            return 0;
        });

        return konkurrencerSorted.find(konkurrence => new Date(new Date(konkurrence.dato).toDateString()) <= new Date(new Date().toDateString()));
    }

    componentDidUpdate(prevProps: any, prevState: SkrivebordLaererState) {
        if (this.state.selectedKonkurrenceId !== prevState.selectedKonkurrenceId) {
            let apiCaller = createApiCaller();
            if (this.state.selectedKonkurrenceId !== undefined && this.state.selectedKonkurrenceId.length > 0) {
                apiCaller.getKonkurrenceOverblik(this.state.selectedKonkurrenceId).then(response => {
                    this.setState({
                        konkurrenceOverblik: response,
                        isLoading: false
                    });
                });
            }
        }
    }

    onKonkurrenceTilLaererSelectChange = (e: any) => {
        let selectedKonkurrence = undefined;
        let konkurrenceId = e.target.value;

        if (konkurrenceId !== undefined && this.state.konkurrencer !== undefined && this.state.konkurrencer.length > 0) {
            selectedKonkurrence = this.state.konkurrencer.find(function (element: any) {
                return element.id === konkurrenceId;
            });
        }

        let selectedKonkurrenceId = selectedKonkurrence !== undefined ? selectedKonkurrence.id : undefined;

        this.setState({
            selectedKonkurrenceId: selectedKonkurrenceId
        });
    }

    getKonkurrenceTilLaererSelect = () => {
        if (this.state.konkurrencer !== undefined && this.state.konkurrencer.length > 0) {
            let konkurrencerFiltered = HelperMethods.distinctArrayByProp(this.state.konkurrencer, 'id');
            const konkurrenceList = konkurrencerFiltered
                .map((k, i) => {
                    const formattedDate = moment(k.dato.toString()).format('DD.MM.YY');
                    // @ts-ignore: this.state.konkurrencer kan ikke være undefined
                    var alleHoldErPaaVenteliste = this.state.konkurrencer.filter(t => t.id === k.id).every(t => t.paaVenteliste);
                    
                    const ventelisteNote = alleHoldErPaaVenteliste ? '(på venteliste)' : '';
                    return <option key={k.id} value={k.id}>{formattedDate} - {k.konkurrenceTitel} {ventelisteNote}</option>;
                });

            return (
                <SelectFormControl
                    label='Vælg konkurrence'
                    value={this.state.selectedKonkurrenceId}
                    onChange={this.onKonkurrenceTilLaererSelectChange}
                    className='konkurrenceTilLaerer-select'
                >
                    {konkurrenceList}
                </SelectFormControl>
            );
        }

        return undefined;
    }

    getKonkurrenceoverblikState() {
        if (this.state.konkurrencer !== undefined && this.state.konkurrencer.length > 0) {
            return (
                <SectionGroup header={'Konkurrenceoverblik'}>
                    {this.getKonkurrenceTilLaererSelect()}
                    <KonkurrenceOverblikContainer
                        konkurrenceId={this.state.selectedKonkurrenceId}
                        isLaererSkrivebord={true}
                        konkurrenceOverblik={this.state.konkurrenceOverblik}
                    />
                </SectionGroup>
            );
        }

        return undefined;
    }

    getTilmeldingerState(headerButtons: any) {
        if (this.state.kommendeKonkurrencer !== undefined) {
            if (this.state.kommendeKonkurrencer.length === 0) {
                return (
                    <SectionGroup header={'Tilmeldinger'} buttons={headerButtons}>
                        <EmptyState header='Du er endnu ikke tilmeldt nogen konkurrencer' />
                        <ButtonSection>
                            <LinkSecondaryButton className='spacer' url='/konkurrencer' text='Tidligere konkurrencer' />
                        </ButtonSection>
                    </SectionGroup>
                );
            } else {
                return (
                    <SectionGroup header={'Tilmeldinger'} buttons={headerButtons}>
                        <Section fullWidth={true}>
                            <KonkurrenceTilLaererEksternTable konkurrencer={this.state.kommendeKonkurrencer} />
                        </Section>
                    </SectionGroup>
                );
            }
        }

        return undefined;
    }

    getKonkurrencerTilInstitutionerUdenLaererState() {
        if (this.state.konkurrencerTilInstitutionerUdenLaerer !== undefined) {
            if (this.state.konkurrencerTilInstitutionerUdenLaerer.length === 0) {
                return (
                    <SectionGroup header={'Tilmelding for din institution'}>
                        <EmptyState header='Du er tilmeldt alle konkurrencer tilknyttet din institution' />
                    </SectionGroup>
                );
            } else {
                return (
                    <SectionGroup header={'Tilmeldinger for din institution'}>
                        <Section fullWidth={true}>
                            <KonkurrenceTilInstitutionUdenLaererTable tilmeldLaererTilKonkurrence={this.tilmeldLaererTilKonkurrence} konkurrencer={this.state.konkurrencerTilInstitutionerUdenLaerer} />
                        </Section>
                    </SectionGroup>
                );
            }
        }
        return undefined;
    }

    tilmeldLaererTilKonkurrence(tilmeldingId: string) {
        var self = this;
        if (self.state.konkurrencerTilInstitutionerUdenLaerer && !self.state.isSubmitting) {
            var konkurrence = self.state.konkurrencerTilInstitutionerUdenLaerer.find(k => k.tilmeldingId === tilmeldingId);
            if (konkurrence) {
                self.setState({ isSubmitting: true });
                createApiCaller().createTilmeldingLaerer(konkurrence)
                    .then(function (response: ValidationResult) {
                        if (response.isValid) {
                            self.getKonkurrencer();
                            self.setState({ isSubmitting: false });
                        }
                    })
                    .catch(() => self.setState({ isSubmitting: false }));
            }
        }
    }

    render() {
        const headerButtons = <div><LinkPrimaryButton url={'/tilmelding'} text={'Tilmeld hold'} /></div>;
        const helpCardTitle = 'Hjælp til ' + getSite().navn;
        const helpCardOpgavepakkeVejledningLinkButtons = this.state.konkurrenceOverblik ? 
            this.state.konkurrenceOverblik.opgavepakkerHelpContent.map(o => <LinkSectionButton key={o.opgavepakkeId} url={'/opgavepakke/vejledning/' + o.opgavepakkeId} text={'Lærervejledninger og materialer - ' + o.opgavepakkeTitel} />)
            : null;

        const helpContent = (
            <div>
                {helpCardOpgavepakkeVejledningLinkButtons}
                <LinkSectionButton url='/support' text='Support' />
            </div>
        );

        const konkurrenceoverblikState = this.getKonkurrenceoverblikState();
        const tilmeldingerState = this.getTilmeldingerState(headerButtons);  
        const konkurrencerTilInstitutionerUdenLaerer = this.getKonkurrencerTilInstitutionerUdenLaererState();      

        if (this.state.isLoading) {
            return <Spinner />;
        }

        return (
            <PageWrapper className='laererskrivebord'>
                <PageTitle title='Skrivebord' />
                <ContentWrapper>
                    {konkurrenceoverblikState}
                    <HelpCardSection title={helpCardTitle} content={helpContent} />
                    {tilmeldingerState}
                    {konkurrencerTilInstitutionerUdenLaerer}
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default SkrivebordLaerer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/SkrivebordLaerer.tsx